exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productCategoryDome .form-col-item[data-v-d1351742]{display:inline-block;width:50%;max-width:400px;vertical-align:top}", ""]);

// exports
